<template>
  <a-row>
    <a-col :span="12">
      <a-row>
        <a-col :span="24">
          <span class="header">{{ $t('content.searchable_field') }}:</span>
          {{ searchableField }}
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="24">
          <span class="header">{{ $t('content.operation') }}:</span>
          {{ $t(`filters.${rule.data.operator}`) }}
        </a-col>
      </a-row>
    </a-col>
    <a-col span="12">
      <div v-if="staticRule">
        <a-row v-if="rule.data.value.data['static-value'] != null">
          <a-col :span="24">
            <span class="header">{{ $t('content.value') }}:</span>
            {{ rule.data.value.data['static-value'] }}
          </a-col>
        </a-row>
      </div>
      <div v-else>
        <a-row>
          <a-col :span="24">
            <span class="header">{{ $t('content.content') }}:</span>
            {{ rule.data.value.data['merge-tag-source-name'] }}
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="24">
            <span class="header">{{ $t('content.field') }}:</span>
            {{ rule.data.value.data['merge-tag'] }}
          </a-col>
        </a-row>
      </div>
    </a-col>
  </a-row>
</template>

<script>
export default {
  name: 'DynamicContentRule',
  props: ['rule'],
  data: function () {
    return {
      staticRule: this.rule.data.value.type === 'STATIC',
      searchableField: this.rule.data['external-source-field']
    };
  }
};
</script>

<style>
.header {
  font-weight: bold;
}
</style>
